import CustomForm from "../../CustomForm";
import m, {Vnode} from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import SliderBox from "../../shared/components/SliderBox/SliderBox";
import KandidatFinale from "./components/KandidatFinale";

export default class KandidatiFinale extends CustomForm {

    public readonly unit: string;
    public readonly steps: number[];
    public readonly decimalPlaces: number;

    private sliderBox: SliderBox;
    private kandidats: (KandidatFinale|null)[] = [];

    constructor(settings: ICustomFormSettings) {
        super(settings);

        this.unit = settings.form.aux1 || '';
        this.steps = [Number(settings.form.aux2 || 0) || 0, Number(settings.form.aux3 || 0) || 0].sort();
        this.decimalPlaces = (''+(this.steps[0] ?? '')).split('.')[1]?.length || 0;

        const layout = settings.form.grid.layout;

        for (let i=0; i<2; i++) {
            try {
                const row = KandidatFinale.parseRow(layout[i]);
                this.kandidats.push(new KandidatFinale(row, this));
            } catch (err) {
                console.warn(`customForm-kandidati-finale: Row(${i}) ${err.message}`);
                this.kandidats.push(null);
            }
        }

        this.sliderBox = new SliderBox(this.kandidats[1]!.slider, null, null, "numeric");
        this.sliderBox.setOnChange(v => this.setValue(v));
    }

    checkRequirements(): boolean {
        if (this.kandidats.filter(k => !k).length) {
            console.warn("customForm-kandidati-finale: Invalid rows with Kandidat.")
            return false;
        }

        return super.checkRequirements();
    }

    private getValue(): number {
        const slider = this.kandidats[1]!.slider;
        return Number(slider.getVariable() ?? slider.initialValue ?? 0);
    }

    private setValue(value: number): void {
        const slider = this.kandidats[1]!.slider;
        const min = slider.range.min;
        const max = slider.range.max;

        value = Math.min( max, Math.max(min, value));
        slider.setVariable( value );
        this.kandidats[0]!.slider.setVariable( max - value );
    }

    private mutateValue(diff: number): void {
        this.setValue( this.getValue() + diff );
    }

    private viewButtons(): Vnode {
        return m('.kandidati-buttons', {}, [
            m( '.kandidati-buttons-minus', {}, this.steps.map(s => m('button.btn', {
                tabindex: 1,
                onclick: () => this.mutateValue(-s),
            }, '+'+s.toLocaleString())).reverse() ),
            m( '.kandidati-buttons-plus', {}, this.steps.map(s => m('button.btn', {
                tabindex: 1,
                onclick: () => this.mutateValue(s),
            }, '+'+s.toLocaleString())) ),
        ])
    }

    public view(): Vnode {
        return this.viewLayout([
            m('.kandidati', {}, this.kandidats.map(k => k?m(k):null)),
            m('.kandidati-controls', {}, [
                m(this.sliderBox),
                this.viewButtons(),
            ])
        ]);
    }

}